import React, { forwardRef } from 'react';
import InputMask from 'react-input-mask';
import '../css/financeiro-parcela-pagar.css';

// Merge fin-pp × feat-malhaAerea: classes .fin-pp__* do redesign + as features da malha —
// prop `inputStyle` (estilo inline do input, usado pela Solicitação de Aéreo via Data.js)
// e label/wrapper CONDICIONAIS (sem label não aplica .fin-pp__field, que tem flex/min-width
// e afetaria o layout mesmo vazia).
const CustomInputLabelExterno = forwardRef(({ inputName = null, onChange = null, placeholder = "", title = "", value = "", id = null, onClick = null, label, readOnly = false, disabled = null, className = "", required = false, autoComplete = undefined, inputStyle = null }, ref) => (
    <div className={label ? "fin-pp__field" : ""}>
        {label ? <label className="fin-pp__label" htmlFor="floatingInput">{label}</label> : null}
        <InputMask
            disabled={disabled}
            ref={ref}
            title={title}
            mask="99/99/9999"
            readOnly={readOnly}
            type="text"
            className={`fin-pp__input ${className}`}
            style={inputStyle ?? undefined}
            name={inputName}
            onChange={onChange}
            value={value}
            id={id}
            onClick={onClick}
            required={required}
            autoComplete={autoComplete}
        />
    </div>
));

export default CustomInputLabelExterno;
